import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f3a046ea&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=f3a046ea&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports